<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline" v-if="commonForm.appID === 'MO'">{{labels.motorRisk}}</div>
      <div class="headline" v-else-if="commonForm.appID === 'TR'">{{labels.travelRisk}}</div>
      <div class="headline" v-else>{{labels.risk}}</div>
    </v-card-title>
    <v-card-text>
      <v-flex lg6 xs12>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <template v-if="commonForm.product">
              <v-flex xs6>
                <v-subheader class="queryLabel">Product</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonForm.product}} - {{commonInfo.productDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.busCls">
              <v-flex xs6>
                <v-subheader class="queryLabel">Business Class</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonForm.busCls}} - {{commonInfo.busClsDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.cover">
              <v-flex xs6>
                <v-subheader class="queryLabel">Cover</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.cover}} - {{commonInfo.coverTypeDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.vehMake">
              <v-flex xs6>
                <v-subheader class="queryLabel">Vehicle Make</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.vehMake}} - {{commonInfo.vehMakeDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.vehModel">
              <v-flex xs6>
                <v-subheader class="queryLabel">Vehicle Model</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.vehModel}} - {{commonInfo.vehModelDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.vehRegNo">
              <v-flex xs6>
                <v-subheader class="queryLabel">Vehicle Registration No.</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.vehRegNo}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.engineNo">
              <v-flex xs6>
                <v-subheader class="queryLabel">Engine No.</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.engineNo}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.chassisNo">
              <v-flex xs6>
                <v-subheader class="queryLabel">Chassis No.</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.chassisNo}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.reqDate">
              <v-flex xs6>
                <v-subheader class="queryLabel">Required Date</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{formatDisplayDate(commonInfo.reqDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.recDate">
              <v-flex xs6>
                <v-subheader class="queryLabel">Received Date</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{formatDisplayDate(commonInfo.recDate)}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.lossPlace">
              <v-flex xs6>
                <v-subheader class="queryLabel">Loss Place</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.lossPlace}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.scheme">
              <v-flex xs6>
                <v-subheader class="queryLabel">Scheme</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonForm.scheme}} - {{commonInfo.schemeDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.planNo">
              <v-flex xs6>
                <v-subheader class="queryLabel">Plan</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonForm.planNo}} - {{commonInfo.planDesc}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.travelType">
              <v-flex xs6>
                <v-subheader class="queryLabel">Travel Type</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{travelType}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.tripType">
              <v-flex xs6>
                <v-subheader class="queryLabel">Trip Type</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{tripType}}</span>
              </v-flex>
            </template>
            <template v-if="commonInfo.travelArea">
              <v-flex xs6>
                <v-subheader class="queryLabel">Travel Area</v-subheader>
              </v-flex>
              <v-flex xs6>
                <span>{{commonInfo.travelArea}} - {{commonInfo.travelAreaDesc}}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { travelType, tripType } from '@/const/underwriting/travel'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        motorRisk: 'Motor Risk Information',
        travelRisk: 'Travel Risk Information',
        risk: 'Risk Information',
        appName: 'Name as in NRIC/Passport',
        appSalutation: 'Salutation'
      }
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    commonForm() {
      return this.claimDetail.commonForm
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    travelType() {
      return travelType[this.commonInfo.travelType]
    },
    tripType() {
      return tripType[this.commonInfo.tripType]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  }
}
</script>

<style>

</style>
